import { SERVER } from './env';

export const TOKEN = 'token';
export const SESSION = 'profile';
export const TEAM = 'current_team';
export const CAMPAIGN_STATUS = 'current_campaign';
export const WAS_SHOW_MODAL_CAMPAIGN = 'was_show_modal_campaign';
export const AREAS = 'areas';
export const SCORE = 'score';
export const LANGUAGE = 'language';
export const ES = 'es';
export const EN = 'en';
export const PT = 'pt';
export const NEW_CAMPAIGN_EVENT = 'NEW_CAMPAIGN_EVENT';
export const SHOW_MODAL_NEW_CAMPAIGN_EVENT = 'SHOW_MODAL_NEW_CAMPAIGN';

export const STORES = {
    IOS: 'https://itunes.apple.com/us/app/gameif/id1413309011?l=es&ls=1&mt=8',
    ANDROID: 'https://play.google.com/store/apps/details?id=com.gameif.loftpublicidad',
    WEB: 'https://gameif.media'
};

export const ASSETS = {
    AVATAR_PLAYER: `${SERVER}s3/`,
    IMAGE_QUESTIONS: `${SERVER}s3/preguntas/`,
    ICONS_CATEGORIES: `${SERVER}public/icons-categories/`,
    ICONS_ACHIEVEMENTS: `${SERVER}public/icons-achievements/`,
    PATH_LOGO: `${SERVER}s3/logo/`,
}

export const AUTH = {
    LOGIN: `${SERVER}v1/app/auth/login`,
    VERIFY: `${SERVER}v1/app/auth/verify`,
    DEVICE_INFO: `${SERVER}v1/app/auth/device-info`,
    CHECK_VERSION: `${SERVER}v1/app/auth/check-version`,
    DOWNLOAD_AVATAR: `${SERVER}v1/app/auth/avatar/`,
    SET_AVATAR: `${SERVER}v1/app/auth/set-avatar/`,
    SET_AVATAR_V2: `${SERVER}v1/app/auth/set-avatar/v2/`,
    UPDATE_PLAYER_ID: `${SERVER}v1/app/auth/player-id/`,
    SET_PASSWORD: `${SERVER}v1/app/auth/set-password/`,
    SET_PASSWORD_V2: `${SERVER}v1/app/auth/set-password/v2/`,
    PASSWORD_RECOVERY: `${SERVER}v1/app/auth/password-recovery`,
    PLAYER_AREAS: `${SERVER}v1/app/auth/areas/`,
}

export const DESAFIO_PERSONAL = {
    SUGERENCIAS: `${SERVER}v1/app/retos-personales/sugerencias/`,
    ALEATORIO: `${SERVER}v1/app/retos-personales/aleatorio/`,
    DIRECTO: `${SERVER}v1/app/retos-personales/directo/`,
    ACTUALIZA: `${SERVER}v1/app/retos-personales/actualiza/`,
    EN_CURSO: `${SERVER}v1/app/retos-personales/en-curso/`,
    CADUCADOS: `${SERVER}v1/app/retos-personales/caducados/`,
    MI_TURNO: `${SERVER}v1/app/retos-personales/en-curso/mi-turno/`,
    SU_TURNO: `${SERVER}v1/app/retos-personales/en-curso/su-turno/`,
    RESPONDER_MI_TURNO: `${SERVER}v1/app/retos-personales/mi-turno/`,
    PRIMER_DESAFIO: `${SERVER}v1/app/retos-personales/primer-desafio/`,
    SCORE: `${SERVER}v1/app/retos-personales/score/`,
    BUSCAR_JUGADOR: `${SERVER}v1/app/retos-personales/buscar/`,
    PUEDE_RETAR: `${SERVER}v1/app/retos-personales/puede-retar/`,
    RETO_BOT: `${SERVER}v1/app/retos-personales/bot/`,
    SAVE_STATS_BOT: `${SERVER}v1/app/retos-personales/bot/estadisticas`,
}

export const DESAFIO_EQUIPO = {
    ESTATUS: `${SERVER}v1/app/retos-equipo/estatus/`,
    SIGUIENTE_RONDA: `${SERVER}v1/app/retos-equipo/siguiente-ronda/`,
    TABLERO: `${SERVER}v1/app/retos-equipo/tablero/`,
    GUARDA_ESTADISTICA: `${SERVER}v1/app/retos-equipo/guarda-estadistica/`
}

export const DASHBOARD = {
    ESTADISTICAS: `${SERVER}v1/app/estadisticas/`,
    ESTADISTICAS_RETOS: `${SERVER}v1/app/estadisticas/retos/`,
    ESTADISTICAS_PREGUNTAS: `${SERVER}v1/app/estadisticas/preguntas/`,
    ESTADISTICAS_EFECTIVIDAD: `${SERVER}v1/app/estadisticas/efectividad/`,
    ESTADISTICAS_CATEGORIAS: `${SERVER}v1/app/estadisticas/categorias/`,
    ESTADISTICAS_COPAS: `${SERVER}v1/app/estadisticas/copas/`,
    CATEGORIAS: `${SERVER}v1/app/estadisticas/detalle-categorias/`,
    LEADERBOARD: `${SERVER}v1/app/estadisticas/leaderboard/`,
    LEADERBOARD_V2: `${SERVER}v1/app/estadisticas/v2/leaderboard/`,
    MAS_RETOS_JUGADOS: `${SERVER}v1/app/estadisticas/mas-retos-jugados/`,
    MAS_RETOS_GANADOS: `${SERVER}v1/app/estadisticas/mas-retos-ganados/`,
    MAS_RETOS_PERDIDOS: `${SERVER}v1/app/estadisticas/mas-retos-perdidos/`,
    VS: `${SERVER}v1/app/estadisticas/vs/`,
    DETALLE_RONDA: `${SERVER}v1/app/estadisticas/detalle-ronda/`,
    HISTORIAL_RETOS: `${SERVER}v1/app/estadisticas/historico-retos/`,
    EXISTE_HISTORIAL_RETOS: `${SERVER}v1/app/estadisticas/existe-historico-retos/`,
}

export const ACHIEVEMENTS = {
    LISTA: `${SERVER}v1/app/insignias/`,
    NUEVOS_LOGROS: `${SERVER}v1/app/insignias/nuevas-insignias/`
}

export const CAMPAIGN = {
    ACTIVE: `${SERVER}v1/app/retos-personales/campaigns/active/`,
    ESTADISTICAS: `${SERVER}v1/app/estadisticas/campaigns/mis-estadisticas/`
}

export const CERTIFICADOS = {
    GET: `${SERVER}v1/app/certificados/`,
}

export const BUSQUEDA_TESORO = {
    ACTIVA: `${SERVER}v1/app/busqueda-tesoro/`,
    HISTORIAL: `${SERVER}v1/app/busqueda-tesoro/historial/`,
    NIVELES_USUARIO: `${SERVER}v1/app/busqueda-tesoro/niveles/`,
    SELECCIONA_SEDE: `${SERVER}v1/app/busqueda-tesoro/agrega-seleccion`,
    OBTEN_PREGUNTAS_NIVEL: `${SERVER}v1/app/busqueda-tesoro/preguntas/`,
    ACTUALIZA_ESTADISTICAS: `${SERVER}v1/app/busqueda-tesoro/actualiza-estadisticas`,
    TESORO: `${SERVER}v1/app/busqueda-tesoro/tesoro/`,
}

export const MATERIALES_APOYO = {
    GET: `${SERVER}v1/app/materiales-apoyo/`,
    GET_ONE: `${SERVER}v1/app/materiales-apoyo/material/`,
    VISTO: `${SERVER}v1/app/materiales-apoyo/visto`,
    LIKE: `${SERVER}v1/app/materiales-apoyo/like/`,
}

export const NOTIFICACIONES = {
    GET: `${SERVER}v1/app/notificaciones/`,
}


